import { type PimProductV13 } from '@redteclab/api/clients/bully'
import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { crossSellAccessorGetLocalizedProductName } from '../../cross-sell'
import { type TENANT, type TenantLanguage } from '../../tenant'

export const cartIntermediateAccessorGetProductName = ({
  language,
  product,
  tenant,
}: {
  language: TenantLanguage
  product: CrossSellProduct | PimProductV13
  tenant: TENANT
}): string => {
  /**
   * Handle type check:
   * - `upid` - PimProductV13
   * - `id` - CrossSellProduct
   */
  if ('upid' in product) {
    return product.name
  }

  return crossSellAccessorGetLocalizedProductName({
    language,
    product,
    tenant,
  })
}
